import { Cookies } from 'react-cookie';

// Instância única compartilhada com o React via <CookiesProvider>: o `useCookies`
// só re-renderiza quando quem escreve é a mesma instância que ele observa.
const cookies = new Cookies();

const ACCESS_KEYS = ['token', 'userImage', 'userName'];
const REFRESH_KEY = 'refreshToken';

const PATH = { path: '/' };

// O acesso vive pouco e é renovado pelo refresh; o refresh é o que decide por
// quanto tempo o admin fica sem digitar a senha de novo.
const ACCESS_MAX_AGE = 86400;
const REFRESH_MAX_AGE = 30 * 86400;

/**
 * Os cookies de sessão são lidos tanto pelo React (via `useCookies`) quanto pelo
 * interceptor do axios, que roda fora de qualquer componente. Este módulo é o
 * único lugar que sabe os nomes e as validades, para os dois lados não saírem
 * de sincronia.
 */
const Session = {
  getToken() {
    return cookies.get('token');
  },

  getRefreshToken() {
    return cookies.get(REFRESH_KEY);
  },

  getUserImage() {
    return cookies.get('userImage');
  },

  getUserName() {
    return cookies.get('userName');
  },

  save({ token, refreshToken, userImage, userName }) {
    cookies.set('token', token, { ...PATH, maxAge: ACCESS_MAX_AGE });
    cookies.set('userImage', userImage || '', {
      ...PATH,
      maxAge: REFRESH_MAX_AGE,
    });
    cookies.set('userName', userName || '', {
      ...PATH,
      maxAge: REFRESH_MAX_AGE,
    });

    if (refreshToken) {
      cookies.set(REFRESH_KEY, refreshToken, {
        ...PATH,
        maxAge: REFRESH_MAX_AGE,
      });
    }
  },

  setUserImage(userImage) {
    cookies.set('userImage', userImage || '', {
      ...PATH,
      maxAge: REFRESH_MAX_AGE,
    });
  },

  setUserName(userName) {
    cookies.set('userName', userName || '', {
      ...PATH,
      maxAge: REFRESH_MAX_AGE,
    });
  },

  /** Guarda só o par renovado, sem tocar no perfil já em cache. */
  saveTokens({ token, refreshToken }) {
    cookies.set('token', token, { ...PATH, maxAge: ACCESS_MAX_AGE });
    cookies.set(REFRESH_KEY, refreshToken, {
      ...PATH,
      maxAge: REFRESH_MAX_AGE,
    });
  },

  clear() {
    [...ACCESS_KEYS, REFRESH_KEY].forEach(key => cookies.remove(key, PATH));
  },
};

export { ACCESS_KEYS, REFRESH_KEY, cookies };
export default Session;
